import { Component } from '@angular/core';

@Component({
  selector: 'app-view-all-notifications',
  templateUrl: './view-all-notifications.component.html'
})
export class ViewAllNotificationsComponent {
  showorderstatusdata: boolean = false;
  notificationheaderInfo: any;

  notificationChangeEventdata(data: any) {
    this.notificationheaderInfo = data;
  }
}
